import { between, getNumberValuesToCompare, isArrayOfNumbers, isValueEmpty } from '../utils';
export function valueIsBetween(givenValue, expectedValue) {
    if (isValueEmpty(givenValue)) {
        return false;
    }
    if (!Array.isArray(expectedValue) || expectedValue.length !== 2) {
        throw new Error('Expected value should be array of two elements');
    }
    const values = getNumberValuesToCompare(givenValue, expectedValue[0], expectedValue[1]);
    if (isArrayOfNumbers(values)) {
        const [given, firstBound, secondBound] = values;
        return between(given, Math.min(firstBound, secondBound), Math.max(firstBound, secondBound));
    }
    throw new Error(`Between operator: Unsupported values to compare ${givenValue}, ${JSON.stringify(expectedValue)}`);
}

//# sourceMappingURL=between.js.map